import { PopUpModal } from "./ModalDialog";
import ReactDOM from "react-dom";

import createFormContext from "../../context/formContext";

const { FormStateProvider: ModalStateProvider, useStore: useModalStore } = createFormContext({
    title: '',
    message: '',
});

export {useModalStore}

export function PopUp({ zIndex, onClose, show = true, setShow, config, setAction, mode, data = {} }) {
    // When used with modalStackContext, show will be true and onClose will be provided
    // When used directly, show and setShow will be provided
    const handleClose = () => {
        if (onClose) {
            onClose();
        } else if (setShow) {
            setShow(false);
        }
    };

    return ReactDOM.createPortal(
        <ModalStateProvider>
            <PopUpModal 
                zIndex={zIndex} 
                onClose={handleClose} 
                show={show} 
                setShow={setShow || handleClose} 
                config={config} 
                setAction={setAction} 
                mode={mode} 
                data={data}
            />
        </ModalStateProvider>
    , document.body);
}
